import axios from '../axiosApi';
import {
    FETCH_DIARIOS_PRODUCAO,
    FETCH_ESTACOES_TRABALHO,
    FETCH_LISTA_OSs, FETCH_LOGIN_LOGOUTS,
    FETCH_LOGIN_LOGOUTS_HOJE,
    FETCH_METAS,
    FETCH_METAS_PERIODO,
    FETCH_OS_SLA,
    FETCH_PNEUS_CONCLUIDOS_POR_DATA,
    FETCH_PNEUS_ENVIADOS_POR_DATA,
    FETCH_PNEUS_NA_CASA,
    FETCH_PNEUS_PRODUZIDOS_HOJE,
    FETCH_PNEUS_RECEBIDOS_HOJE,
    FETCH_PNEUS_RECEBIDOS_POR_DATA,
    FETCH_PNEUS_RECUSADOS_REPROVADOS_HOJE,
    FETCH_PNEUS_RECUSADOS_REPROVADOS_POR_DATA,
    FETCH_PNEUS_SAIDOS_HOJE,
    FETCH_PROCESSOS,
    FETCH_SALDOS,
    RECEIVE_DIARIOS_PRODUCAO,
    RECEIVE_ESTACOES_TRABALHO,
    RECEIVE_LISTA_OSs, RECEIVE_LOGIN_LOGOUTS,
    RECEIVE_LOGIN_LOGOUTS_HOJE,
    RECEIVE_METAS,
    RECEIVE_METAS_PERIODO,
    RECEIVE_OS_SLA,
    RECEIVE_PNEUS_CONCLUIDOS_POR_DATA,
    RECEIVE_PNEUS_ENVIADOS_POR_DATA,
    RECEIVE_PNEUS_NA_CASA,
    RECEIVE_PNEUS_PRODUZIDOS_HOJE,
    RECEIVE_PNEUS_RECEBIDOS_HOJE,
    RECEIVE_PNEUS_RECEBIDOS_POR_DATA,
    RECEIVE_PNEUS_RECUSADOS_REPROVADOS_HOJE,
    RECEIVE_PNEUS_RECUSADOS_REPROVADOS_POR_DATA,
    RECEIVE_PNEUS_SAIDOS_HOJE,
    RECEIVE_PROCESSOS,
    RECEIVE_SALDOS
} from "./actionTypes";
import {fetchRecebidosFinalizados, receiveRecebidosFinalizados} from "./orderActions";


export const fetchEstacoesTrabalho =  () => ({
    type: FETCH_ESTACOES_TRABALHO
});

export const receiveEstacoesTrabalho = payload => ({
    type: RECEIVE_ESTACOES_TRABALHO,
    payload: payload
})

export const fetchLoginLogoutsHoje =  () => ({
    type: FETCH_LOGIN_LOGOUTS_HOJE
});

export const receiveLoginLogoutsHoje = payload => ({
    type: RECEIVE_LOGIN_LOGOUTS_HOJE,
    payload: payload
})

export const fetchPneusNaCasa =  () => ({
    type: FETCH_PNEUS_NA_CASA
});

export const receivePneusNaCasa = payload => ({
    type: RECEIVE_PNEUS_NA_CASA,
    payload: payload
})

export const fetchListaOSs =  () => ({
    type: FETCH_LISTA_OSs
});

export const receiveListaOSs = payload => ({
    type: RECEIVE_LISTA_OSs,
    payload: payload
})


export const fetchPneusRecebidosHoje =  () => ({
    type: FETCH_PNEUS_RECEBIDOS_HOJE
});

export const receivePneusRecebidosHoje = payload => ({
    type: RECEIVE_PNEUS_RECEBIDOS_HOJE,
    payload: payload
})




export const fetchPneusSaidosHoje =  () => ({
    type: FETCH_PNEUS_SAIDOS_HOJE
});

export const receivePneusSaidosHoje = payload => ({
    type: RECEIVE_PNEUS_SAIDOS_HOJE,
    payload: payload
})

export const fetchPneusProduzidosHoje =  () => ({
    type: FETCH_PNEUS_PRODUZIDOS_HOJE
});

export const receivePneusProduzidosHoje = payload => ({
    type: RECEIVE_PNEUS_PRODUZIDOS_HOJE,
    payload: payload
})

export const fetchPneusRecusadosReprovadosHoje =  () => ({
    type: FETCH_PNEUS_RECUSADOS_REPROVADOS_HOJE
});

export const receiveRecusadosReprovadosHoje = payload => ({
    type: RECEIVE_PNEUS_RECUSADOS_REPROVADOS_HOJE,
    payload: payload
})



export const fetchOSSLA =  () => ({
    type: FETCH_OS_SLA
});

export const receiveOSSLA = payload => ({
    type: RECEIVE_OS_SLA,
    payload: payload
})


export const fetchRecebidosPorData =  () => ({
    type: FETCH_PNEUS_RECEBIDOS_POR_DATA
});

export const receiveRecebidosPorData = payload => ({
    type: RECEIVE_PNEUS_RECEBIDOS_POR_DATA,
    payload: payload
})

export const fetchEnviadosPorData =  () => ({
    type: FETCH_PNEUS_ENVIADOS_POR_DATA
});

export const receiveEnviadosPorData = payload => ({
    type: RECEIVE_PNEUS_ENVIADOS_POR_DATA,
    payload: payload
})

export const fetchConcluidosPorData =  () => ({
    type: FETCH_PNEUS_CONCLUIDOS_POR_DATA
});

export const receiveConcluidosPorData = payload => ({
    type: RECEIVE_PNEUS_CONCLUIDOS_POR_DATA,
    payload: payload
})

export const fetchRecusadosReprovadosPorData =  () => ({
    type: FETCH_PNEUS_RECUSADOS_REPROVADOS_POR_DATA
});

export const receiveRecusadosReprovadosPorData = payload => ({
    type: RECEIVE_PNEUS_RECUSADOS_REPROVADOS_POR_DATA,
    payload: payload
})

export const fetchProcessos =  () => ({
    type: FETCH_PROCESSOS
});

export const receiveProcessos = payload => ({
    type: RECEIVE_PROCESSOS,
    payload: payload
})


export const fetchMetas=  () => ({
    type: FETCH_METAS
});

export const receiveMetas = payload => ({
    type: RECEIVE_METAS,
    payload: payload
})

export const fetchMetasPeriodo=  () => ({
    type: FETCH_METAS_PERIODO
});

export const receiveMetasPeriodo = payload => ({
    type: RECEIVE_METAS_PERIODO,
    payload: payload
})

export const fetchDiariosProducao =  () => ({
    type: FETCH_DIARIOS_PRODUCAO
});

export const receiveDiariosProducao = payload => ({
    type: RECEIVE_DIARIOS_PRODUCAO,
    payload: payload
})

export const fetchSaldos =  () => ({
    type: FETCH_SALDOS
});

export const receiveSaldos = payload => ({
    type: RECEIVE_SALDOS,
    payload: payload
})



export const fetchLoginLogouts=  () => ({
    type: FETCH_LOGIN_LOGOUTS
});

export const receiveLoginLogouts = payload => ({
    type: RECEIVE_LOGIN_LOGOUTS,
    payload: payload
})

export const getEstacoesTrabalho = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            console.log("getEstacoesTrabalho Mock");
            return;
        }

        dispatch(fetchEstacoesTrabalho());
        let payload;
        try {

            let url = `/estacao-trabalhos?filter={"include":[ "operador" ] }`;
            const response = await axios.get(url)
            console.log("response estacoesTrabalho", response);
            payload = response.data;
        }
        catch(e) {
            //console.log("getServiceOrderDetail.catch.error", e);
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveEstacoesTrabalho(payload));
        }
    }
}

export const getLoginLogoutsHoje = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            console.log("getLoginLogoutsHoje Mock");
            return;
        }

        dispatch(fetchLoginLogoutsHoje());
        let payload;
        try {

            const today = new Date();
            const dtHoje = today.toISOString().substring(0, 8)+today.getDate().toString().padStart(2,'0')+'T00:00:00';

            let url = `/operador-logins?filter={"where": { "or": [  { "dt" : { "gte" : "${dtHoje}"  }   }, { "dtLogout" : null }    ] }   }`;
            const response = await axios.get(url)
            console.log("response loginLogoutsHoje", response);
            payload = response.data;
        }
        catch(e) {

            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveLoginLogoutsHoje(payload));
        }
    }
}



export const getPneusNaCasa = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            console.log("getPneusNaCasa Mock");
            return;
        }


        dispatch(fetchPneusNaCasa());
        let payload;
        try {
            //
            // const estabelecimento =  getState().filter.estabelecimentoId;

            console.log("getOperadoresLogados");

            let url = `/ordem-servicos/pneus-em-casa`;
            const response = await axios.get(url)
            console.log("response pneusnacasa", response);
            payload = response.data;
        }
        catch(e) {
            //console.log("getServiceOrderDetail.catch.error", e);
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receivePneusNaCasa(payload));
        }
    }
}

export const getListaCabecalhoOSRecapados = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }

        dispatch(fetchListaOSs());
        let payload;
        try {
            //
            // const estabelecimento =  getState().filter.estabelecimentoId;

            console.log("getOperadoresLogados");
            const { periodMin, periodMax } = getState().filter;
            let url = `/ordem-servicos/lista-os-recapados?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            const response = await axios.get(url)
            console.log("response getListaCabecalhoOSRecapados", response);
            payload = response.data;
        }
        catch(e) {
            //console.log("getServiceOrderDetail.catch.error", e);
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveListaOSs(payload));
        }
    }
}




export const getPneusRecebidosHoje = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }



        dispatch(fetchPneusRecebidosHoje());
        let payload;
        try {
            const today = new Date();
            const dtHoje = today.toISOString().substring(0, 8)+today.getDate().toString().padStart(2,'0')+'T00:00:00';


            let url = `/ordem-servicos?filter={ "where": { "DTChegada": { "gte": "${dtHoje}" } }, "fields":[ "id", "ordemServicoId", "DTChegada", "DTInicioProducao", "DTFimProducao", "DTSaida", "etapaAtual", "DTUltimaEtapa", "prioridadeId"   ] }`;
            console.log("getPneusRecebidosHoje", dtHoje , url);
            const response = await axios.get(url)
            payload = response.data;
        }
        catch(e) {
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receivePneusRecebidosHoje(payload));
        }
    }
}

export const getPneusSaidosHoje = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }


        dispatch(fetchPneusSaidosHoje());
        let payload;
        try {
            //
            // const estabelecimento =  getState().filter.estabelecimentoId;

            const today = new Date();
            const dtHoje = today.toISOString().substring(0, 8)+today.getDate().toString().padStart(2,'0')+'T00:00:00'

            let url = `/ordem-servicos?filter={ "where": { "DTSaida": { "gte": "${dtHoje}" } }, "fields":[ "id", "ordemServicoId", "DTChegada", "DTInicioProducao", "DTFimProducao", "DTSaida", "etapaAtual", "DTUltimaEtapa", "prioridadeId"   ] }`;
            console.log("getPneusSaidosHoje", dtHoje, url);
            const response = await axios.get(url)
            console.log("response saidos", response);
            payload = response.data;
        }
        catch(e) {
            //console.log("getServiceOrderDetail.catch.error", e);
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receivePneusSaidosHoje(payload));
        }
    }
}

export const getPneusProduzidosHoje = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }

        dispatch(fetchPneusProduzidosHoje());
        let payload;
        try {
            //
            // const estabelecimento =  getState().filter.estabelecimentoId;

            const today = new Date();
            const dtHoje = today.toISOString().substring(0, 8)+today.getDate().toString().padStart(2,'0')+'T00:00:00'

            let url =  `/ordem-servicos?filter={ "where": { "and": [ { "DTFimProducao": { "gte": "${dtHoje}" }}, { "statusOrdemServicoId" : { "inq": [2] } }, { "processoId": 1 } ] }, "fields":[ "id", "ordemServicoId", "DTChegada", "DTInicioProducao", "DTFimProducao", "DTSaida", "etapaAtual", "DTUltimaEtapa", "prioridadeId"   ] }`;
            console.log("recapados", url);
            const response = await axios.get(url);
            console.log("response getPneusProduzidosHoje.recapados", response);

            let url2 = `/ordem-servicos?filter={ "where": { "and": [ { "DTFimProducao": { "gte": "${dtHoje}" }}, { "statusOrdemServicoId" : { "inq": [2] } }, { "processoId": 2 }  ] }, "fields":[ "id", "ordemServicoId", "DTChegada", "DTInicioProducao", "DTFimProducao", "DTSaida", "etapaAtual", "DTUltimaEtapa", "prioridadeId"   ] }`;
            console.log("vulcanizados", url2);
            const response2 = await axios.get(url2)
            console.log("response getPneusProduzidosHoje.vulcanizados", response2);

            let url3 = `/ordem-servicos?filter={ "where": { "and": [ { "DTFimProducao": { "gte": "${dtHoje}" }},  { "teveRetrabalho": true }] }, "fields":[ "id", "ordemServicoId", "DTChegada", "DTInicioProducao", "DTFimProducao", "DTSaida", "etapaAtual", "DTUltimaEtapa", "prioridadeId"   ] }`;
            console.log("retrabalho", url3);
            const response3 = await axios.get(url3)
            console.log("response getPneusProduzidosHoje.retrabalho", response3);


            console.log("response getPneusProduzidosHoje", response, response2, response3);


            payload = {
                recapadosHoje: response.data? response.data : [],
                consertadosHoje: response2.data? response2.data : [] ,
                retrabalhadosHoje: response3.data? response3.data : [] ,
            };

        }
        catch(e) {
            console.log("ERROR getPneusProduzidosHoje.catch.error", e);
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receivePneusProduzidosHoje(payload));
        }
    }
}

export const getPneusRecusadosReprovadosHoje = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }

        dispatch(fetchPneusRecusadosReprovadosHoje());
        let payload;
        try {
            //
            // const estabelecimento =  getState().filter.estabelecimentoId;

            const today = new Date();
            const dtHoje = today.toISOString().substring(0, 8)+today.getDate().toString().padStart(2,'0')+'T00:00:00'


            let url = `/ordem-servicos?filter={ "where": { "and": [ { "DTFimProducao": { "gte": "${dtHoje}" }}, { "statusOrdemServicoId" : { "inq": [3] } }] }, "fields":[ "id", "ordemServicoId", "DTChegada", "DTInicioProducao", "DTFimProducao", "DTSaida", "etapaAtual", "DTUltimaEtapa", "prioridadeId"   ] }`;
            const response = await axios.get(url)

            let url2 = `/ordem-servicos?filter={ "where": { "and": [ { "DTFimProducao": { "gte": "${dtHoje}" }}, { "statusOrdemServicoId" : { "inq": [7] } }] }, "fields":[ "id", "ordemServicoId", "DTChegada", "DTInicioProducao", "DTFimProducao", "DTSaida", "etapaAtual", "DTUltimaEtapa", "prioridadeId"   ] }`;

            const response2 = await axios.get(url2)


            payload = {
                recusados : response.data,
                reprovados: response2.data
            }
        }
        catch(e) {
            //console.log("getServiceOrderDetail.catch.error", e);
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveRecusadosReprovadosHoje(payload));
        }
    }
}


export const getSaldos = () => {
    return async (dispatch,getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }

        dispatch(fetchSaldos());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;
            const url2 = `/ordem-servicos/saldos?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            const response = await axios.get(url2)
            payload =  {
                saldos: response.data
            }
        }
        catch(e) {
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveSaldos(payload));
        }
    }
}



export const getRecebidosPorData= () => {
    return async (dispatch,getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }

        dispatch(fetchRecebidosPorData());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;
            const url2 = `/ordem-servicos/recebidos-count?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            const response = await axios.get(url2)
            payload =  {
                recebidosPorData: response.data
            }
        }
        catch(e) {
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveRecebidosPorData(payload));
        }
    }
}

export const getEnviadosPorData= () => {
    return async (dispatch,getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }

        dispatch(fetchEnviadosPorData());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;
            const url2 = `/ordem-servicos/enviados-count?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            const response = await axios.get(url2)
            payload =  {
                enviadosPorData: response.data
                
            }
        }
        catch(e) {
            payload = { error: true, message: e };
                
            window.location.reload(true); console.log("ERROR trycatch ",e)
            
        }
        finally {
            dispatch(receiveEnviadosPorData(payload));
        }
    }
}

export const getConcluidosPorData= () => {
    return async (dispatch,getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }


        dispatch(fetchConcluidosPorData());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;

            const url = `/ordem-servicos/recapados-count?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            const response = await axios.get(url)


            const url2 = `/ordem-servicos/consertados-count?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            const response2 = await axios.get(url2)


            const url3 = `/ordem-servicos/retrabalhados-count?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            const response3 = await axios.get(url3)
            payload =  {
                recapadosPorData: response.data,
                consertadosPorData: response2.data,
                retrabalhadosPorData: response3.data
            }


        }
        catch(e) {
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveConcluidosPorData(payload));
        }
    }
}

export const getRecusadosReprovadosPorData= () => {
    return async (dispatch,getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }

        dispatch(fetchRecusadosReprovadosPorData());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;

            const url = `/ordem-servicos/recusados-count?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            const response = await axios.get(url)

            const url2 = `/ordem-servicos/reprovados-count?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            const response2 = await axios.get(url2)
            payload =  {
                recusadosPorData: response.data,
                reprovadosPorData: response2.data
            }
        }
        catch(e) {
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveRecusadosReprovadosPorData(payload));
        }
    }
}

export const getProcessos = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            console.log("getProcessos Mock");
            return;
        }

        dispatch(fetchProcessos());
        let payload = []
        try {
            const today = new Date();
            const url = `/processos?filter={ "include": [  {  "relation" :  "processoEtapas" , "scope": {  "include": [  {  "relation": "processoEtapaQuestoes", "scope": { "include": [ { "relation": "processoEtapaQuestaoRespostas" }  ]   }   } ]  }  }  ] } `;
            console.log('processos url', url);
            const response = await axios.get(url)
            payload = response.data;
        }
        catch(e) {
            //console.log("getServiceOrderDetail.catch.error", e);
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveProcessos(payload));
        }
    }
}

export const getOSSLA = () => {
    return async (dispatch) => {
        dispatch(fetchOSSLA());
        let payload;
        try {
            const url = `/ordem-servicos/sla`;
            console.log('processos url', url);
            const response = await axios.get(url)
            payload = response.data;
        }
        catch(e) {
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveOSSLA(payload));
        }
    }
}

export const getMetas = () => {
    return async (dispatch,getState) => {
        dispatch(fetchMetas());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;
            const url = `/metas`;
            console.log("metas", url);
            const response = await axios.get(url)
            payload =  {
                metas: response.data
            }
        }
        catch(e) {
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveMetas(payload));
        }
    }
}

export const getMetasPeriodo = () => {
    return async (dispatch,getState) => {
        const bMock = getState().i4.mock;
        if (bMock) {
            return;
        }


        dispatch(fetchMetasPeriodo());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;
            const url = `/metas/periodo?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;

            const response = await axios.get(url)
          console.log("metasperiodo", url, response.data);
            payload =  {
                metasPeriodo: response.data
            }
        }
        catch(e) {
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveMetasPeriodo(payload));
        }
    }
}



export const getDiariosProducao = () => {
    return async (dispatch,getState) => {
        dispatch(fetchDiariosProducao());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;
            const url = `/diario-producaos?filter={ "where": { "data":  { "between": ["${periodMin}","${periodMax}"] } } }`;
            const response = await axios.get(url)
            payload =  {
                diariosProducao: response.data
            }
        }
        catch(e) {
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveDiariosProducao(payload));
        }
    }
}


export const getLoginLogouts = () => {
    return async (dispatch,getState) => {
        dispatch(fetchLoginLogouts());
        let payload;
        try {
            const da = new Date();
            const min = da.getFullYear() + '-' + (da.getMonth() + 1).toString().padStart(2,'0') +'-' + da.getDate().toString().padStart(2,'0')

            const { periodMin, periodMax } = getState().filter;

            let url = `/operador-logins?filter={"where":{ "dt" : { "between": ["${periodMin}","${periodMax}"] }   }  }`;
            console.log("operadorLogin", url);
            const response = await axios.get(url)
            payload =  {
                loginLogouts: response.data
            }
        }
        catch(e) {
            payload = { error: true, message: e };
            window.location.reload(true); console.log("ERROR trycatch ",e)
        }
        finally {
            dispatch(receiveLoginLogouts(payload));
        }
    }
}